import { Snackbar, Alert } from "@mui/material";

const ComingSoonSnackbar = ({ open, onClose, message = "Coming Soon!" }) => (
  <Snackbar
    open={open}
    autoHideDuration={3000}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  >
    <Alert onClose={onClose} severity="info" sx={{ width: "100%" }}>
      {message}
    </Alert>
  </Snackbar>
);

export default ComingSoonSnackbar;
